<app-header></app-header>
<div class="divSpace">
    <router-outlet></router-outlet>
  </div>
<app-footer></app-footer>
<div class="imgUpPage" (click)="scrollToTop()">
  <img width="100%" src="/assets/images/general/BTN_UP.png">
</div>
